import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import FiltersAccordionBasicSection from './components/Section/BasicSection';
import FiltersAccordionTagSection from './components/Section/TagsSection';

const FiltersAccordion = props => {
  const {
    filters,
    disabled,
    onClickHandler = () => {},
    onGroupSelectAll = () => {},
    onGroupClearAll = () => {},
    onChange = () => {},
    onSearch = () => {},
    onPushValue = () => {},
    compact = false,
  } = props;

  const handleClick = e => {
    onClickHandler(e);
  };

  const [toggledIndex, setToggledIndex] = useState(null);

  const accordions = useMemo(() => {
    return Object.keys(filters).map((sectionKey, index) => {
      const { groups, title } = filters[sectionKey];

      const selected = Object.keys(groups).some(key => {
        const { elements = [], type, selectedElements } = groups[key];

        if (type === 'range') {
          const min = parseInt(elements[0], 10);
          const max = parseInt(elements[elements.length - 1], 10);
          return selectedElements
            && selectedElements.length
            && (
              parseInt(selectedElements[0], 10) !== min
              || parseInt(selectedElements[1], 10) !== max
            );
        }

        if (type === 'datePicker') {
          return selectedElements;
        }

        if (sectionKey === 'candidate-tags') {
          return selectedElements && selectedElements.length;
        }

        return elements.some(element => element.selected);
      });

      const disableAction = () => {};

      const toggledIndexHandler = index => {
        setToggledIndex(index);
      };

      return sectionKey === 'candidate-tags' ? (
        <FiltersAccordionTagSection
          key={index}
          title={title}
          toggledIndex={toggledIndex}
          toggleIndex={index}
          toggleFunc={toggledIndexHandler}
          selected={selected}
          sectionKey={sectionKey}
          groups={groups}
          disabled={disabled}
          onChange={disabled ? disableAction : onChange}
          onSearch={disabled ? disableAction : onSearch}
          onPushValue={disabled ? disableAction : onPushValue}
          onSelectAll={disabled ? disableAction : onGroupSelectAll}
          onClearAll={disabled ? disableAction : onGroupClearAll}
        />
      ) : (
        <FiltersAccordionBasicSection
          key={index}
          title={title}
          toggledIndex={toggledIndex}
          toggleIndex={index}
          toggleFunc={toggledIndexHandler}
          selected={selected}
          sectionKey={sectionKey}
          groups={groups}
          disabled={disabled}
          onChange={disabled ? disableAction : onChange}
          onSearch={disabled ? disableAction : onSearch}
          onPushValue={disabled ? disableAction : onPushValue}
          onSelectAll={disabled ? disableAction : onGroupSelectAll}
          onClearAll={disabled ? disableAction : onGroupClearAll}
        />
      );
    });
  }, [filters, toggledIndex]);

  const onClearAllWithSelection = () => {
    setToggledIndex(null);
    props.onClearAll();
    window.scrollTo(0, 0);
  };

  const onResetToDefaultHandler = props.onResetToDefault ? () => {
    setToggledIndex(null);
    props.onResetToDefault();
    window.scrollTo(0, 0);
  } : undefined;

  const renderProps = {
    ...props,
    accordions,
    onClearAllWithSelection,
    onResetToDefault: onResetToDefaultHandler,
  };

  return (
    <div
      className={
        !compact
          ? 'filters-accordion'
          : 'filters-accordion filters-accordion--compact'
      }
      onClick={handleClick}
    >
      {props.render(renderProps)}
    </div>
  );
};

FiltersAccordion.propTypes = {
  disabled: PropTypes.bool,
  compact: PropTypes.bool,
  onClickHandler: PropTypes.func,
  title: PropTypes.string,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  filters: PropTypes.object,
  onGroupSelectAll: PropTypes.func,
  onGroupClearAll: PropTypes.func,
  onChange: PropTypes.func,
  onClearAll: PropTypes.func,
  onSearch: PropTypes.func,
  onPushValue: PropTypes.func,
};

export default FiltersAccordion;
